<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2" small>mdi-text-box-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Valor Desarchivo</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-4">
								<v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newUnarchiveValue.name"
                    label="Nombre (Identificador)"
                    placeholder="Ingrese nombre / descrición para el valor del desarchivo"
                    outlined
                    required
                    dense
										hide-details
										class="mb-2"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
								<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newUnarchiveValue.value"
									type="number"
									step="1"
									label="Valor Desarchivo en CLP"
									placeholder="Ingrese el valor del desarchivo en pesos chilenos"
									outlined
									required
									dense
									hide-details
									class="custom-height-search custom-height-calendar mt-1"
									style="font-size: 14px;"
									:rules="requiredRule"
									@keydown.enter.prevent
									@keypress="validateCLP"
									@input="sanitizeIntegerInput"
								></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {createOrUpdateCompanyUnarchiveValue} from '@/helpers/api/company'

export default {
  name: 'CompanyUnarchiveValuesModal',
  components: { },
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
    newUnarchiveValue: {
			company_unarchive_value_id: null,
			name: null,
			value: 0,
			currency_id: 1
    },
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		if(this.$store.state.companies.newUnarchiveValueModalEditing){
			this.newUnarchiveValue = this.$store.state.companies.newUnarchiveValueModalEditing
		}
		this.$store.dispatch('companies/getCompanyUnarchiveValues')
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		validateCLP(e) {
			if (e.key === 'e') {
				e.preventDefault()
			}
			if(e.target?.value > 9999999999){
				e.preventDefault();
			}
		},
		sanitizeIntegerInput() {
			this.newUnarchiveValue = {
				...this.newUnarchiveValue,
				value: this.newUnarchiveValue.value
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '') || 0
			}
			this.setItemUfValueFromClp()
		},
    closeModal(){
      this.$store.commit('companies/setNewUnarchiveValueModal', false)
			this.$store.commit('companies/setCompanyUnarchiveValueModalEditing', null)
      this.newUnarchiveValue = {
				company_unarchive_value_id: null,
				name: null
			}
      this.validform = true
      this.loadingData = false
    },
    async sendForm(){
      if(this.$refs.form.validate()){
				this.loadingData = true
        const company = await createOrUpdateCompanyUnarchiveValue(this.newUnarchiveValue)
        if(company.code === 200){
          const messageData = {
            message: this.newUnarchiveValue.company_unarchive_value_id ? 'El destino ha sido actualizado':'Se ha creado correctamente el destino',
            title: this.newUnarchiveValue.company_unarchive_value_id ? 'Destino Actualizado':'Destino creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.$store.dispatch('companies/getCompanyUnarchiveValues')
          this.setMessage(messageData)
          this.closeModal()
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
				this.loadingData = false
      }
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }

  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>